import React from 'react';
import { useLocation } from 'react-router-dom';
import { useQnAContext } from './contexts/QnAContext';
import styles from './QnAWidget.module.scss';
import { QnAWidgetIcon } from './QnAWidgetIcon';
import { QnAWidgetWindow } from './QnAWidgetWindow';

export function QnAWidget() {
  const { isExpanded, toggleExpanded } = useQnAContext();
  const { pathname } = useLocation();

  if (pathname.startsWith('/tools')) {
    return null;
  }

  return (
    <div className={`${styles.widgetContainer} ${isExpanded ? styles.expanded : ''}`}>
      <QnAWidgetWindow />
      <QnAWidgetIcon onClick={toggleExpanded} />
    </div>
  );
}
